{
  "dependencies": {
    "@angular/cli": "^20.1.0",
    "@nestjs/mapped-types": "*"
  },
  "name": "tab",
  "version": "3.1.1",
  "description": "MEKH Tájékoztatási Adatbázis (TAB)",
  "scripts": {
    "release": "standard-version --commit-all",
    "release-next": "standard-version --commit-all --prerelease next --skip.changelog=true -t DEV-"
  },
  "repository": {
    "type": "git",
    "url": "https://gitlab.itwizard.hu/mekh/hattab.git"
  },
  "author": "Zoltán Paulovics",
  "license": "ISC",
  "private": true,
  "devDependencies": {
    "prettier": "^3.6.0",
    "standard-version": "^9.5.0"
  }
}
